module.exports = __webpack_public_path__ + "media/kate_rocket_ship.091313cf.mp3";